const LEADFEEDER_SCRIPT_SELECTOR = 'script[src*="sc.lfeeder.com/lftracker"]';

/**
 * Loads the Dealfront / Leadfeeder Web Visitors tracker when REACT_APP_LEADFEEDER_SITE_ID is set.
 * Runs once for the SPA shell so all routes are covered.
 */
export function initLeadfeeder() {
  const siteId = process.env.REACT_APP_LEADFEEDER_SITE_ID?.trim();
  if (!siteId || typeof document === 'undefined') return;
  if (document.querySelector(LEADFEEDER_SCRIPT_SELECTOR)) return;

  window.ldfdr =
    window.ldfdr ||
    function () {
      (window.ldfdr._q = window.ldfdr._q || []).push([].slice.call(arguments));
    };

  const scriptUrl = `https://sc.lfeeder.com/lftracker_v1_${siteId}.js`;
  const firstScript = document.getElementsByTagName('script')[0];

  if (firstScript?.parentNode) {
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptUrl;
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = scriptUrl;
  document.head.appendChild(script);
}
